import {DashboardBlockOne} from "./DashboardBlockOne";
import {DashboardBlockTwo} from "./dashboardBlockTwo";
import styles from './categoryFood.module.sass'
import React from "react";

export const CategoryFood = () => {
    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 20}}>
            <div className={styles.divider}></div>
            <DashboardBlockOne/>
            <DashboardBlockTwo/>
        </div>
    );
};

